<template>
  <div v-if="sortList" class="catalog-filter-sort">
    <a
      v-for="item in sortList"
      :key="item.sort.request"
      :href="item.request"
      :class="{ 'catalog-filter-sort__item_active': item.active }"
      @click.prevent="handlerChangeSort(item)"
    >
      {{ item.name }}
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@store';

const { state, dispatch, commit } = useStore();
const router = useRouter();

const sortList = computed(() => state?.catalog?.data?.catalogSort?.items);

const handlerChangeSort = (item) => {
  try {
    router.replace(item.request);
    dispatch('catalog/changePageData', item.request);
    commit('catalog/openFilter', false);
  } catch (err) {
    console.error(err);
  }
};
</script>

<script>
export default {
  name: 'CatalogFilterSort',
};
</script>

<style lang="scss" scoped>
.catalog-filter-sort {
  display: grid;
  grid-row-gap: 20px;
  font-weight: 500;
  font-size: rem(14);
  line-height: 100%;
  color: #030304;
  &__item {
    &_active {
      color: var(--color-dark-grey);
    }
  }
}
</style>
